import React from "react";
import PropTypes from "prop-types";
import styles from "components/documents/active-filters.scss";
import { dataType } from "custom-prop-types";
import { ActiveFilterItem } from "components/documents/filters/active-filter-item";

export const ActiveDigitalFilters = ({
  accountId,
  onRemoveSourceFilter,
  onRemoveStuckStatusFilter,
  sourceFilter,
  statusFilter
}) => {
  const isEmptyResult = isEmpty(
    sourceFilter,
    statusFilter
  );
  if (isEmptyResult) {
    return null;
  }
  return (
    <div className={ styles.container }>
      {renderSelectedItems("document source", sourceFilter, () => onRemoveSourceFilter(accountId))}
      {renderSelectedItems("processing status", statusFilter, () => onRemoveStuckStatusFilter(accountId))}
    </div>
  );
};

ActiveDigitalFilters.propTypes = {
  accountId: PropTypes.string.isRequired,
  onRemoveSourceFilter: PropTypes.func.isRequired,
  onRemoveStuckStatusFilter: PropTypes.func.isRequired,
  sourceFilter: dataType,
  statusFilter: dataType
};

ActiveDigitalFilters.defaultProps = {
  sourceFilter: null,
  statusFilter: null
};

const renderSelectedItems = (name, item, onRemoveItem) => {
  if (item === null) {
    return null;
  }
  return (
    <div className={ styles["active-filter-group"] }>
      <span className={ styles["group-title"] }>Selected {name}</span>
      <div>
        {renderItem(item, onRemoveItem, name)}
      </div>
    </div>
  );
};

const renderItem = (item, onRemoveItem, name) => (
  <span key={ `${name}-${item}` }>
    <ActiveFilterItem name={ `${item.name}` } onRemove={ onRemoveItem } />
  </span>
);

const isEmpty = (
 sourceFilter,
 statusFilter,
) => (
  sourceFilter === null
  && statusFilter === null
);



// WEBPACK FOOTER //
// ./src/js/components/upload-documents/active-digital-filters.jsx